var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement, nothing } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { adminMessageShown$, bottomSheet$, modal$, } from '../stores/store-main.js';
import './element-contact-form.js';
import { classMap } from 'lit/directives/class-map.js';
import Hammer from 'hammerjs';
import { crossSvg } from '../helpers/elements.js';
import { guard } from 'lit/directives/guard.js';
const DefaultSwipeStates = ['quarter', 'half', 'open', 'close'];
const OrderedSwipeStates = [
    'close',
    'quarter',
    'half',
    'threeQuarters',
    'open',
];
const BIG_SWIPE_THRESHOLD = 120;
const SMALL_SWIPE_THRESHOLD = 50;
let ElementBottomSheet = class ElementBottomSheet extends LitElement {
    constructor() {
        super(...arguments);
        this.adminMessageShown = adminMessageShown$.value;
        this.state = 'open';
        this.swipeStates = DefaultSwipeStates;
        this.isMoving = false;
        this.isScrolling = false;
        this.timeout = null;
        this.topValue = 'top: 0px';
        this.y = 0;
        this.startY = 0;
        this.subscriptions = [];
    }
    render() {
        if (!this.options)
            return '';
        return html ` ${this.options.data.darkSurround
            ? html `<div
              class="bg-black/50 z-50 w-full absolute bottom-0 top-0"
            ></div>` : nothing}
      <div
        class="w-full relative z-50 left-0 pointer-events-auto overflow-overlay ${classMap({
            'h-screen-wo-header': !this.adminMessageShown,
            'h-screen-wo-header-message': this.adminMessageShown,
            'transition-[top]': !this.isMoving,
            ease: !this.isMoving,
            'duration-[.4s]': !this.isMoving,
            'bg-chm-tertiary-gray': this.options.data.greyBg,
            'bg-white': !this.options.data.greyBg,
        })}"
        style="${this.topValue}"
        @wheel="${(e) => this.handleScroll(e)}"
      >
        <div
          class="w-content mx-auto grid grid-cols-4 sm:grid-cols-8 mdxx:grid-cols-12"
        >
          <div
            class="bottom-sheet-pan cursor-pointer flex justify-between col-span-full xxl:col-[3_/_span_8]"
          >
            <div class="min-w-[24px]"></div>
            <div
              class="w-[188px] h-[8px] bg-chm-light-gray rounded-[6px] mt-[8px]"
            ></div>
            <div>
              ${this.options.data.showCloseBtn
            ? html `<button
                      data-cy="close"
                      class="group relative top-[9px] md:top-[16px] flex cursor-pointer items-center link-with-icon-alone clickable-icon-with-text"
                      @click="${() => {
                bottomSheet$.next(undefined);
                this.state = 'close';
                this.updateTopValue();
            }}"
                    >
                      <div class="hidden md:block">Fermer</div>
                      ${crossSvg('clickable-icon-in-group')}
                    </button>` : ''}
            </div>
          </div>
          <div
            class="bottom-sheet-content mt-[12px] md:mt-[24px] col-span-full xxl:col-[3_/_span_8]"
          >
            ${this.options.guardElementRender
            ? guard(this.options.guardDependencies, () => this.contentElement)
            : this.contentElement}
          </div>
        </div>
      </div>`;
    }
    close() {
        this.state = 'close';
        setTimeout(() => {
            bottomSheet$.next(undefined);
        }, 300);
    }
    updateTopValue() {
        const screenHeight = this.scrollContainer?.getBoundingClientRect().height || 0;
        let topValue = screenHeight;
        if (this.isMoving) {
            topValue = this.y;
        }
        else if (this.state === 'quarter') {
            topValue = screenHeight * (3 / 4);
        }
        else if (this.state === 'half') {
            topValue = screenHeight / 2;
        }
        else if (this.state === 'threeQuarters') {
            topValue = screenHeight * (1 / 4);
        }
        else if (this.state === 'open') {
            topValue = 0;
        }
        else if (this.state === 'close') {
            topValue = screenHeight;
        }
        this.topValue = `top: ${topValue}px`;
    }
    handleScroll(e) {
        clearTimeout(this.timeout);
        if (!this.isScrolling) {
            this.startY = e.target.scrollTop;
            this.isScrolling = true;
        }
        this.timeout = setTimeout(() => {
            this.isScrolling = false;
            this.scrollEnd(e);
        }, 50);
    }
    scrollEnd(e) {
        const deltaY = e.deltaY;
        let orderedStates = this.swipeStates.sort((a, b) => {
            return OrderedSwipeStates.indexOf(a) - OrderedSwipeStates.indexOf(b);
        });
        if (deltaY < 0) {
            orderedStates = orderedStates.reverse();
        }
        const stateIndex = orderedStates.findIndex((s) => s === this.state);
        this.state =
            orderedStates.find((s, i) => i > stateIndex && orderedStates.includes(s)) || this.state;
        if (this.state === 'close') {
            this.close();
        }
        this.updateTopValue();
    }
    fitContentSize(contentHeight) {
        if (this.state === 'close')
            return;
        const screenHeight = this.scrollContainer?.getBoundingClientRect().height || 0;
        const panHeight = this.panElm?.getBoundingClientRect()?.height || 0;
        contentHeight += panHeight;
        if (this.adminMessageShown && this.topNotificationEl) {
            const topNotifHeight = this.topNotificationEl.getBoundingClientRect().height;
            contentHeight += topNotifHeight;
        }
        if (contentHeight < screenHeight * (1 / 4)) {
            this.state = 'quarter';
        }
        else if (contentHeight < screenHeight / 2) {
            this.state = 'half';
        }
        else if (contentHeight < screenHeight * (3 / 4)) {
            this.state = 'threeQuarters';
        }
        else {
            this.state = 'open';
        }
        this.updateTopValue();
    }
    isContentFitSize(contentHeight) {
        const screenHeight = this.scrollContainer?.getBoundingClientRect().height || 0;
        const panHeight = this.panElm?.getBoundingClientRect()?.height || 0;
        contentHeight += panHeight;
        if (this.adminMessageShown && this.topNotificationEl) {
            const topNotifHeight = this.topNotificationEl.getBoundingClientRect().height;
            contentHeight += topNotifHeight;
        }
        if (this.state === 'quarter') {
            return contentHeight < screenHeight * (1 / 4);
        }
        else if (this.state === 'half') {
            return contentHeight < screenHeight / 2;
        }
        else if (this.state === 'threeQuarters') {
            return contentHeight < screenHeight * (3 / 4);
        }
        else {
            return true;
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('scrollContainer') && this.scrollContainer) {
            this.updateTopValue();
        }
        if (changedProperties.has('options') && this.options) {
            this.swipeStates = this.options.data.swipeStates || DefaultSwipeStates;
            this.state = this.options.data.state;
            this.updateTopValue();
            this.panel = new Hammer(this.panElm);
            this.panel.get('pan').set({ direction: Hammer.DIRECTION_ALL });
            this.panel.on('panup pandown', (evt) => {
                const screenHeight = this.scrollContainer.getBoundingClientRect().height;
                const minBottomValue = screenHeight;
                const newY = evt.center.y - this.getBoundingClientRect().top;
                if (newY < 0)
                    this.y = 0;
                else if (newY < minBottomValue)
                    this.y = newY;
                else
                    this.y = minBottomValue;
                this.updateTopValue();
            });
            this.panel.on('panstart', (evt) => {
                this.startY = evt.center.y;
                this.isMoving = true;
            });
            this.panel.on('panend', (evt) => {
                this.isMoving = false;
                const deltaY = this.startY - evt.center.y;
                const distToBottom = window.innerHeight - evt.center.y;
                const closingZoneHeight = Math.min(100, window.innerHeight / 8);
                if (distToBottom < closingZoneHeight) {
                    this.close();
                    this.updateTopValue();
                }
                else {
                    const bigSwipeUp = deltaY > BIG_SWIPE_THRESHOLD;
                    const smallSwipeUp = deltaY > SMALL_SWIPE_THRESHOLD;
                    const smallSwipeDown = deltaY < -SMALL_SWIPE_THRESHOLD;
                    switch (this.state) {
                        case 'quarter':
                            if (bigSwipeUp && this.swipeStates.includes('open')) {
                                this.state = 'open';
                            }
                            else if ((bigSwipeUp && this.swipeStates.includes('threeQuarters')) ||
                                (smallSwipeUp && !this.swipeStates.includes('half'))) {
                                this.state = 'threeQuarters';
                            }
                            else if (smallSwipeUp && this.swipeStates.includes('half')) {
                                this.state = 'half';
                            }
                            else if (smallSwipeDown) {
                                this.close();
                            }
                            break;
                        case 'half':
                            if (smallSwipeUp && this.swipeStates.includes('threeQuarters')) {
                                this.state = 'threeQuarters';
                            }
                            else if (smallSwipeUp && this.swipeStates.includes('open')) {
                                this.state = 'open';
                            }
                            else if (smallSwipeDown) {
                                this.state = 'quarter';
                            }
                            break;
                        case 'threeQuarters':
                            if (smallSwipeUp && this.swipeStates.includes('open')) {
                                this.state = 'open';
                            }
                            else if (smallSwipeDown && this.swipeStates.includes('half')) {
                                this.state = 'half';
                            }
                            else if (smallSwipeDown &&
                                this.swipeStates.includes('quarter')) {
                                this.state = 'quarter';
                            }
                            break;
                        case 'open':
                            if (deltaY < 4 * -BIG_SWIPE_THRESHOLD) {
                                this.close();
                            }
                            else if (deltaY < 2 * -BIG_SWIPE_THRESHOLD &&
                                this.swipeStates.includes('quarter')) {
                                this.state = 'quarter';
                            }
                            else if (smallSwipeDown &&
                                this.swipeStates.includes('threeQuarters')) {
                                this.state = 'threeQuarters';
                            }
                            else if (smallSwipeDown && this.swipeStates.includes('half')) {
                                this.state = 'half';
                            }
                            break;
                    }
                    this.updateTopValue();
                }
            });
        }
        else if (changedProperties.has('options') &&
            !this.options &&
            this.panel) {
            delete this.panel;
        }
        if (changedProperties.has('state')) {
            this.dispatchEvent(new CustomEvent('stateChanged'));
        }
        super.updated(changedProperties);
    }
    connectedCallback() {
        const bottomSheetSubscription = bottomSheet$.subscribe((options) => {
            if (options && modal$.value) {
                modal$.next(undefined);
            }
            if (options) {
                this.scrollContainer?.classList.add('!overflow-hidden');
                const showCloseBtn = options.data.showCloseBtn;
                options.data = {
                    ...options.data,
                    showCloseBtn: showCloseBtn !== undefined ? showCloseBtn : true,
                };
            }
            else {
                this.scrollContainer?.classList.remove('!overflow-hidden');
            }
            this.options = options;
            if (options) {
                this.contentElement =
                    typeof options.element === 'function'
                        ? options.element(this)
                        : options.element;
            }
        });
        const adminMsgSubscription = adminMessageShown$.subscribe((shown) => {
            this.adminMessageShown = shown;
        });
        this.subscriptions.push(bottomSheetSubscription, adminMsgSubscription);
        super.connectedCallback();
    }
    disconnectedCallback() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
        super.disconnectedCallback();
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: Object })
], ElementBottomSheet.prototype, "scrollContainer", void 0);
__decorate([
    property({ type: Object })
], ElementBottomSheet.prototype, "topNotificationEl", void 0);
__decorate([
    state()
], ElementBottomSheet.prototype, "options", void 0);
__decorate([
    state()
], ElementBottomSheet.prototype, "adminMessageShown", void 0);
__decorate([
    state()
], ElementBottomSheet.prototype, "state", void 0);
__decorate([
    state()
], ElementBottomSheet.prototype, "swipeStates", void 0);
__decorate([
    state()
], ElementBottomSheet.prototype, "isMoving", void 0);
__decorate([
    state()
], ElementBottomSheet.prototype, "isScrolling", void 0);
__decorate([
    state()
], ElementBottomSheet.prototype, "timeout", void 0);
__decorate([
    state()
], ElementBottomSheet.prototype, "topValue", void 0);
__decorate([
    state()
], ElementBottomSheet.prototype, "contentElement", void 0);
__decorate([
    query('.bottom-sheet-pan')
], ElementBottomSheet.prototype, "panElm", void 0);
ElementBottomSheet = __decorate([
    customElement('element-bottom-sheet')
], ElementBottomSheet);
export default ElementBottomSheet;
//# sourceMappingURL=element-bottom-sheet.js.map